import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { WhatIf } from "./components/sections/WhatIf";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Challenges } from "./components/sections/Challenges";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { PurchaseInfo } from "./components/sections/PurchaseInfo";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3iiwdwl3utc1n">
      <MetaPixel data-id="element-1" data-mp="3mkrdnl64zhdb" />
      <Hero data-id="element-2" data-mp="3mk8710lxsfel" />
      <main data-id="element-3" data-mp="3mjztr7lwj82v">
        <WhatIf data-id="element-4" data-mp="3mjg9hk8s47lo" />
        <BeforeAfter data-id="element-5" data-mp="3rc9em985thya" />
        <Challenges data-id="element-6" data-mp="3rbrayrj641gc" />
        <Volumes data-id="element-7" data-mp="3rdarmj8qkein" />
        <Tools data-id="element-8" data-mp="3rcsxbs5mwadd" />
        <Bonuses data-id="element-9" data-mp="3recdlirailf5" />
        <Offer data-id="element-10" data-mp="5yi8qe3h5da" />
        <PurchaseInfo data-id="element-11" data-mp="6hr7hlrojf6" />
        <Testimonials data-id="element-12" data-mp="4wyzymxdckh" />
        <Author data-id="element-13" data-mp="56n1goet9nj" />
        <Faq data-id="element-14" data-mp="7suzhf7pr6a" />
        <FinalCta data-id="element-15" data-mp="2zl3cxocsjc6w" />
      </main>
      <Footer data-id="element-16" data-mp="2zm4yimrfnh2v" />
      <FloatingCta data-id="element-17" data-mp="2zmemk4sx3e5x" />
      <PurchasePopup data-id="element-18" data-mp="2zn69yscd25l4" />
    </div>;
}